export const NumberFormatters = {
  methods: {
    abbrNum(number, decPlaces) {
      if (number === 0) { return 0 }
      if (!!number && number % 1 != 0) {
        number = number.toFixed(2)
      }

      decPlaces = Math.pow(10,decPlaces);
      let abbrev = [ "k", "m", "b", "t" ];

      for (let i=abbrev.length-1; i>=0; i--) {
        let size = Math.pow(10,(i+1)*3)
        if(size <= number) {
          number = Math.round(number*decPlaces/size)/decPlaces
          if((number == 1000) && (i < abbrev.length - 1)) {
            number = 1
            i++
          }
          number += abbrev[i]
          break
        }
      }
      return number
    },

    numberWithCommas(number) {
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    removeCommas(number) {
      return parseFloat(number.replace(/,/g, ''))
    },

    roundUpNumber(number, base) {
      return Math.ceil((number + 1)/base) * base
    },

    shortenNumber(number, useCurrency) {
      // from: https://stackoverflow.com/a/55987576
      let n = parseInt(number),
        isDecimal = number > 0 && number < 1,
        isNeg = n < 0,
        absNumber = Math.abs(n),
        shortNumber

      switch (true) {
        case (absNumber >= 1e3 && absNumber < 1e6):
          shortNumber = `${+(absNumber / 1e3).toFixed(1)}k`
          break
        case (absNumber >= 1e6 && absNumber < 1e9):
          shortNumber = `${+(absNumber / 1e6).toFixed(1)}m`
          break
        case (absNumber >= 1e9 && absNumber < 1e12):
          shortNumber = `${+(absNumber / 1e9).toFixed(1)}b`
          break
        case (absNumber >= 1e12):
          shortNumber = `${+(absNumber / 1e12).toFixed(1)}t`
          break
        default:
          shortNumber = (isDecimal || useCurrency) ? Number(n).toFixed(2) : absNumber
      }

      let currencyNumber = isNeg ? `-$${shortNumber}` : `$${shortNumber}`
      shortNumber = isNeg ? `-${shortNumber}` : shortNumber
      return useCurrency ? currencyNumber : shortNumber
    }
  }
}